"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.thirdPartySignerGuardManifest = void 0;
const generated_1 = require("../generated");
const guards_1 = require("../guards");
/**
 * The thirdPartySigner guard requires a predefined
 * address to sign the mint transaction. The signer will need
 * to be passed within the mint settings of this guard.
 *
 * This allows for more centralized mints where every single
 * mint transaction has to go through a specific signer.
 */
exports.thirdPartySignerGuardManifest = {
    name: 'thirdPartySigner',
    serializer: generated_1.getThirdPartySignerSerializer,
    mintParser: (context, mintContext, args) => ({
        data: new Uint8Array(),
        remainingAccounts: [{ signer: args.signer, isWritable: true }],
    }),
    routeParser: guards_1.noopParser,
};
//# sourceMappingURL=thirdPartySigner.js.map